import ActivityHeader from './activityHeader.view';

export default ActivityHeader;
